import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown, NumericInputField} from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function InsuranceOrderingEditTemplate({ insuranceOrderingEditViewStore }) {
    const {
        contentLoading,
        form,
        insuranceStore
    } = insuranceOrderingEditViewStore;

    return (
        <ApplicationEditLayout store={insuranceOrderingEditViewStore}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-8 col-lrg-7">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('id')} store={insuranceStore}/>
                                </div>

                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                    <NumericInputField field={form.$('primarySort')} />
                                </div> 

                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                    <NumericInputField field={form.$('secondarySort')} />
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

InsuranceOrderingEditTemplate.propTypes = {
    insuranceOrderingEditViewStore: PropTypes.object,
};

export default defaultTemplate(InsuranceOrderingEditTemplate);
